import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { toast } from 'sonner';
import { Api, useApiFormSubmit } from '../../api';
import { useForm } from 'react-typed-form';
import { FieldText } from '../../form';
import { useInvalidation } from 'api-read-hook';

type Props = {
  open: boolean;
  onClose: () => void;
  feedback: Api.Feedback.UserV_ListAsAdmin;
};

export default function NoteModal({ open, onClose, feedback }: Props) {
  const { invalidateMatching } = useInvalidation();

  const form = useForm<{ adminNote: string | null }>({
    defaultValues: { adminNote: feedback.adminNote || '' },
    onSubmit: useApiFormSubmit('PATCH', feedback['@id'], {
      onSuccess: () => {
        invalidateMatching('/feedback');
        toast.success('Note saved successfully');
        onClose();
      },
    }),
  });

  const handleSave = async () => {
    await form.handleSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '60vh',
        },
      }}
    >
      <DialogTitle>
        {feedback.adminNote ? 'Edit Note' : 'Create Note'}
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <FieldText
          field={form.getField('adminNote')}
          label=""
          multiline
          rows={6}
          placeholder="Add a note about this feedback..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={form.isLoading || !form.getField('adminNote').value?.trim()}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
